import { z } from 'zod';
const contactSchema = z.object({
    name: z.string().min(1, 'required'),
    relationship: z.string().min(1, 'required'),
    phone1: z.string().min(1, 'required'),
    phone2: z.string().default(''),
    address: z.string().default(''),
    city: z.string().default(''),
    state: z.string().default(''),
    zipcode: z.string().default(''),
    canEvacuate: z.string().default(''),
});
const equipmentSchema = z.object({
    name: z.string().default(''),
    vendor: z.string().default(''),
    vendorPhone: z.string().default(''),
    requiresPower: z.string().default(''),
});
export const emergencyPreparednessValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        // Patient functional status
        livesAlone: z.string().min(1, 'required'),
        floorLevel: z.string().min(1, 'required'),
        stairsToExit: z.string().min(1, 'required'),
        mobilityStatus: z.string().min(1, 'required'),
        ambulatoryAid: z.string().default(''),
        weightBearing: z.string().min(1, 'required'),
        oxygenUse: z.string().min(1, 'required'),
        oxygenLPM: z.string().default(''),
        cognitiveStatus: z.string().min(1, 'required'),
        specialNeeds: z.string().default(''),
        petInfo: z.string().default(''),
        // Emergency contacts
        contacts: z.array(contactSchema).default([]),
        // Evacuation plan
        primaryDestination: z.string().min(1, 'required'),
        primaryAddress: z.string().default(''),
        primaryCity: z.string().default(''),
        primaryState: z.string().default(''),
        primaryZipcode: z.string().default(''),
        primaryPhone: z.string().min(1, 'required'),
        alternateDestination: z.string().default(''),
        alternateAddress: z.string().default(''),
        alternateCity: z.string().default(''),
        alternateState: z.string().default(''),
        alternateZipcode: z.string().default(''),
        alternatePhone: z.string().default(''),
        transportMethod: z.string().min(1, 'required'),
        transportNotes: z.string().default(''),
        shelterRegistered: z.string().default(''),
        shelterName: z.string().default(''),
        evacuationAssistance: z.string().min(1, 'required'),
        // Medication go-bag
        hasMedList: z.string().default(''),
        medListLocation: z.string().default(''),
        daysSupply: z.string().default(''),
        pharmacyName: z.string().default(''),
        pharmacyPhone: z.string().default(''),
        controlledSubstances: z.string().default(''),
        refrigeratedMeds: z.string().default(''),
        refrigeratedNotes: z.string().default(''),
        medNotes: z.string().default(''),
        // DME / Equipment
        equipment: z.array(equipmentSchema).default([]),
        // Utility notifications
        electricCompany: z.string().default(''),
        electricPhone: z.string().default(''),
        electricAcctNum: z.string().default(''),
        electricNotified: z.boolean().default(false),
        gasCompany: z.string().default(''),
        gasPhone: z.string().default(''),
        waterCompany: z.string().default(''),
        waterPhone: z.string().default(''),
        lifeSustainEquip: z.string().default(''),
        lifeSustainNotified: z.boolean().default(false),
        lifeSustainDate: z.string().default(''),
        // Disaster risk assessment
        floodZone: z.string().default(''),
        evacuationZone: z.string().default(''),
        disasterHurricane: z.boolean().default(false),
        disasterTornado: z.boolean().default(false),
        disasterFlood: z.boolean().default(false),
        disasterFire: z.boolean().default(false),
        disasterWinter: z.boolean().default(false),
        disasterPowerOutage: z.boolean().default(false),
        disasterEarthquake: z.boolean().default(false),
        disasterHazmat: z.boolean().default(false),
        disasterPandemic: z.boolean().default(false),
        disasterHeatWave: z.boolean().default(false),
        disasterNotes: z.string().default(''),
        // Education & acknowledgment
        planReviewedWith: z.string().min(1, 'required'),
        planReviewedDate: z.string().min(1, 'required'),
        copyLeftInHome: z.boolean().default(false),
        locationInHome: z.string().default(''),
        patientVerbalizesUnderstanding: z.boolean().default(false),
        caregiverVerbalizesUnderstanding: z.boolean().default(false),
        localEmergencyNumbers: z.boolean().default(false),
        knowsDialingInstructions: z.boolean().default(false),
        emergencyKitPrepared: z.boolean().default(false),
        weatherAlertMethod: z.string().default(''),
        additionalEducation: z.string().default(''),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
